/**
 * DataExplorerContent  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { TreeView } from "../../ui/components/Tree/TreeView";
import { ITreeNode, TREE_VIEW_STYLE } from "../../ui/components/Tree/TreeViewTypes";
import { useTreeState } from "../../ui/components/Tree/useTreeState";
import { useTreeSelections } from "../../ui/components/Tree/useTreeSelections";

export interface DataExplorerContentProps {}

const items: ITreeNode[] = [
	{
		id: "a",
		label: "todoListItems",
		tooltip: "first thing",
		description: "description",
		isSelected: false,
		defaultExpanded: true,
		flags: [
			{
				icon: "mdi/code-braces",
				tooltip: "Object"
			}
		],
		children: [
			{
				id: "aa",
				label: "isLoading",
				tooltip: "first first thing",
				value: true,
				description: "first",
				isSelected: false,
				defaultExpanded: false
			},
			{
				id: "ab",
				label: "hasData",
				tooltip: "first second thing",
				value: true,
				description: "something",
				isSelected: false,
				defaultExpanded: false
			},
			{
				id: "ac",
				label: "data",
				tooltip: "first third thing",
				description: "items",
				isSelected: false,
				defaultExpanded: false,
				flags: [
					{
						icon: "mdi/mdi-code-braces",
						tooltip: "Object"
					}
				],
				children: [
					{
						id: "aca",
						label: "data1",
						tooltip: "first third thing",
						value: "first third value first third value first third value first third value",
						isSelected: false,
						defaultExpanded: false,
						children: [
							{
								id: "acaa",
								label: "data1",
								tooltip: "first third thing",
								value: "first third value first third value first third value first third value",
								isSelected: false,
								defaultExpanded: false,
								children: [
									{
										id: "acaaa",
										label: "data1",
										tooltip: "first third thing",
										value: "first third value first third value first third value first third value",
										isSelected: false,
										defaultExpanded: false
									}
								]
							}
						]
					},
					{
						id: "acb",
						label: "data2",
						tooltip: "first third thing",
						value: "first third value first third value",
						isSelected: false,
						defaultExpanded: false
					},
					{
						id: "acc",
						label: "data3",
						tooltip: "first third thing",
						value: "first third value first third value",
						description: "aaa",
						isSelected: false,
						defaultExpanded: false
					}
				]
			}
		]
	},
	{
		id: "b",
		label: "headerContainer",
		tooltip: "second thing",
		isSelected: false,
		defaultExpanded: false,
		flags: [
			{
				icon: "mdi/mdi-code-braces",
				tooltip: "Object"
			}
		],
		children: [
			{
				id: "ba",
				label: "First",
				tooltip: "second first thing",
				value: "second first value",
				isSelected: false,
				defaultExpanded: false
			},
			{
				id: "bb",
				label: "Second",
				tooltip: "second second thing",
				value: "second second value",
				isSelected: false,
				defaultExpanded: false
			},
			{
				id: "bc",
				label: "Third",
				tooltip: "second third thing",
				value: "second third value",
				description: "abc",
				isSelected: false,
				defaultExpanded: false
			}
		]
	},
	{
		id: "c",
		label: "optAggregation",
		tooltip: "third thing",
		value: "New app",
		isSelected: false,
		defaultExpanded: false,
		className: "foo-hey",
		actions: [
			{
				icon: "mdi/plus",
				tooltip: "aaaa",
				disabled: false
			}
		]
	}
];

export const DataExplorerContent: React.FC<DataExplorerContentProps> = () => {
	const logEvent = React.useCallback((e) => {
		console.log({ e });
	}, []);

	const [ selections, selectNode ] = useTreeSelections();
	const [ treeState, handleTreeStateUpdate ] = useTreeState({ nodes: { a: { expanded: true } } });

	return (
		<div>
			<TreeView
				items={items}
				state={treeState}
				selections={selections}
				onNodeSelect={selectNode}
				onNodeFlagClick={logEvent}
				onStateUpdate={handleTreeStateUpdate}
				style={TREE_VIEW_STYLE.MONOSPACE}
				compact
				onNodeActionClick={console.log}
				loadData={(node) => {
					console.log(node);
					return Promise.resolve();
				}}
			/>
		</div>
	);
};
